import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Gastos",
    items: [
      { label: "Conceptos", icon: "far fa-list-alt", href: "/ConceptosGastos", key: "gastos.conceptos.ver" },
      { label: "Gastos",    icon: "fas fa-receipt",  href: "/Gastos",          key: "gastos.gastos.ver" },
    ],
  },
];

function BotonesGastos() {
  return (
    <MenuGrid
      title="Gastos"
      subtitle="Administración de gastos y conceptos"
      icon="fas fa-wallet"
      accent={{ color: "#f59e0b", bg: "#fffbeb" }}
      modulo="gastos"
      sections={SECTIONS}
    />
  );
}

export default BotonesGastos;
